/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { projectCalculationsBalanceExcelRetrieve } from '../fn/excel-export/project-calculations-balance-excel-retrieve';
import { ProjectCalculationsBalanceExcelRetrieve$Params } from '../fn/excel-export/project-calculations-balance-excel-retrieve';
import { projectCalculationsCashFlowPlanExcelRetrieve } from '../fn/excel-export/project-calculations-cash-flow-plan-excel-retrieve';
import { ProjectCalculationsCashFlowPlanExcelRetrieve$Params } from '../fn/excel-export/project-calculations-cash-flow-plan-excel-retrieve';
import { projectCalculationsInvestorReportExcelRetrieve } from '../fn/excel-export/project-calculations-investor-report-excel-retrieve';
import { ProjectCalculationsInvestorReportExcelRetrieve$Params } from '../fn/excel-export/project-calculations-investor-report-excel-retrieve';
import { projectCalculationsProfitAndLossPlanExcelRetrieve } from '../fn/excel-export/project-calculations-profit-and-loss-plan-excel-retrieve';
import { ProjectCalculationsProfitAndLossPlanExcelRetrieve$Params } from '../fn/excel-export/project-calculations-profit-and-loss-plan-excel-retrieve';
import { projectCalculationsResultFinAnalysExcelRetrieve } from '../fn/excel-export/project-calculations-result-fin-analys-excel-retrieve';
import { ProjectCalculationsResultFinAnalysExcelRetrieve$Params } from '../fn/excel-export/project-calculations-result-fin-analys-excel-retrieve';
import { projectCalculationsSalesPlanToExcelRetrieve } from '../fn/excel-export/project-calculations-sales-plan-to-excel-retrieve';
import { ProjectCalculationsSalesPlanToExcelRetrieve$Params } from '../fn/excel-export/project-calculations-sales-plan-to-excel-retrieve';

@Injectable({ providedIn: 'root' })
export class BackendApiExcelExportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectCalculationsBalanceExcelRetrieve()` */
  static readonly ProjectCalculationsBalanceExcelRetrievePath = '/api/project_calculations/balance_excel/{id}/';

  /**
   * Экспорт баланса в excel.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsBalanceExcelRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsBalanceExcelRetrieve$Response(
    params: ProjectCalculationsBalanceExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsBalanceExcelRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Экспорт баланса в excel.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsBalanceExcelRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsBalanceExcelRetrieve(
    params: ProjectCalculationsBalanceExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsBalanceExcelRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectCalculationsCashFlowPlanExcelRetrieve()` */
  static readonly ProjectCalculationsCashFlowPlanExcelRetrievePath =
    '/api/project_calculations/cash_flow_plan_excel/{id}/';

  /**
   * Экспорт плана движения денежных средств в excel.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsCashFlowPlanExcelRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsCashFlowPlanExcelRetrieve$Response(
    params: ProjectCalculationsCashFlowPlanExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsCashFlowPlanExcelRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Экспорт плана движения денежных средств в excel.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsCashFlowPlanExcelRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsCashFlowPlanExcelRetrieve(
    params: ProjectCalculationsCashFlowPlanExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsCashFlowPlanExcelRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectCalculationsInvestorReportExcelRetrieve()` */
  static readonly ProjectCalculationsInvestorReportExcelRetrievePath =
    '/api/project_calculations/investor_report_excel/{id}/';

  /**
   * Экспорт отчета инвестора в excel.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsInvestorReportExcelRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsInvestorReportExcelRetrieve$Response(
    params: ProjectCalculationsInvestorReportExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsInvestorReportExcelRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Экспорт отчета инвестора в excel.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsInvestorReportExcelRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsInvestorReportExcelRetrieve(
    params: ProjectCalculationsInvestorReportExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsInvestorReportExcelRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectCalculationsProfitAndLossPlanExcelRetrieve()` */
  static readonly ProjectCalculationsProfitAndLossPlanExcelRetrievePath =
    '/api/project_calculations/profit_and_loss_plan_excel/{id}/';

  /**
   * Экспорт плана прибылей и убытков в excel.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsProfitAndLossPlanExcelRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsProfitAndLossPlanExcelRetrieve$Response(
    params: ProjectCalculationsProfitAndLossPlanExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsProfitAndLossPlanExcelRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Экспорт плана прибылей и убытков в excel.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsProfitAndLossPlanExcelRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsProfitAndLossPlanExcelRetrieve(
    params: ProjectCalculationsProfitAndLossPlanExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsProfitAndLossPlanExcelRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectCalculationsResultFinAnalysExcelRetrieve()` */
  static readonly ProjectCalculationsResultFinAnalysExcelRetrievePath =
    '/api/project_calculations/result_fin_analys_excel/{id}/';

  /**
   * Экспорт результатов финансового анализа в excel.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsResultFinAnalysExcelRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsResultFinAnalysExcelRetrieve$Response(
    params: ProjectCalculationsResultFinAnalysExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsResultFinAnalysExcelRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Экспорт результатов финансового анализа в excel.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsResultFinAnalysExcelRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsResultFinAnalysExcelRetrieve(
    params: ProjectCalculationsResultFinAnalysExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsResultFinAnalysExcelRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectCalculationsSalesPlanToExcelRetrieve()` */
  static readonly ProjectCalculationsSalesPlanToExcelRetrievePath =
    '/api/project_calculations/sales_plan_to_excel/{id}/';

  /**
   * Экспорт плана продаж в excel.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsSalesPlanToExcelRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsSalesPlanToExcelRetrieve$Response(
    params: ProjectCalculationsSalesPlanToExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsSalesPlanToExcelRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Экспорт плана продаж в excel.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsSalesPlanToExcelRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsSalesPlanToExcelRetrieve(
    params: ProjectCalculationsSalesPlanToExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsSalesPlanToExcelRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
